module.exports = __webpack_public_path__ + "img/tab-purification.59ffd94d.png";